export const PLAN_LABEL = { free: 'Free', pro_monthly: 'Pro Monthly', pro_annual: 'Pro Annual' };

export const planStatus = (u) => {
  if (!u.subscription?.startsWith('pro_')) return 'Free';
  const label = PLAN_LABEL[u.subscription] || 'Pro';
  return u.subscription_expires ? `${label} · ends ${new Date(u.subscription_expires).toLocaleDateString()}` : `${label} · permanent`;
};

export const billingSource = (u) => (u.billing_gateway === 'plugnpay' ? 'Card' : u.paypal_subscription_id ? 'PayPal' : null);
